import { render, staticRenderFns } from "./editNotice.vue?vue&type=template&id=218e3860&scoped=true&"
import script from "./editNotice.vue?vue&type=script&lang=js&"
export * from "./editNotice.vue?vue&type=script&lang=js&"
import style0 from "./editNotice.vue?vue&type=style&index=0&id=218e3860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e3860",
  null
  
)

export default component.exports